import { Component, Input, output, input } from '@angular/core';
import {
  LinkField,
  TextField,
  JssModule,
} from '@sitecore-jss/sitecore-jss-angular';
import { NavigationExtras } from '@angular/router';
import { CrntIconButton } from '@essent/current-web-angular';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-modal-page-header',
  templateUrl: './modal-page-header.component.html',
  styleUrls: [
    './modal-page-header.component.ed.scss',
    './modal-page-header.component.essent.scss',
  ],
  standalone: true,
  imports: [JssModule, CrntIconButton, FaIconComponent, GenericLinkDirective],
})
export class ModalPageHeaderComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public title?: TextField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public href?: LinkField;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public navigationExtras?: NavigationExtras;

  readonly isButton = input(false, {
    transform: (value: boolean | string) =>
      typeof value === 'string' ? value === '' : value,
  });

  public closeFunction = output<void>();
}
